// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"351":"d10162b4f8d2523f59db","678":"4aeba3e3a25de14b1f97","682":"1d0916b8c4f2e6f29bea"}[chunkId] + ".js";
};